import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { formatDataCell } from '@/creditflowresearch/ui/components/deals/helpers';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => formatDataCell(tranche.guidanceIpt);

const GuidanceIPTCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="GuidanceIPTCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default GuidanceIPTCell;
